import { cn } from "@/utils/css";
import {
    LoadboardTableCell,
    LoadboardTimestamps,
    LoadboardBidCard,
    LoadboardCargoInfo,
    LoadboardBrokerInfo,
    LoadboardMapSection,
} from "@/components/dataPages/loadboard";
import { TableRow } from "@/components/common/table/table";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { API } from "@/services/API";
import { today } from "@/utils/date";
import { useQuery as useUrlQuery } from "@/utils/query";

export const LoadboardToggleRow = ({ load, isOpen, withTimestamps = true }) => {
    const { trailerType } = useUrlQuery();

    const firstStop = useMemo(() => load.itineraryStops[0], [load.itineraryStops]);
    const lastStop = useMemo(() => load.itineraryStops[load.itineraryStops.length - 1], [load.itineraryStops]);

    const CMRate = useQuery({
        queryKey: ["loadPriceAndTrend", firstStop?.zip, lastStop?.zip, trailerType, load.pickupDate],
        queryFn: () =>
            API.get("/analytics/load-price-and-trend", {
                params: {
                    departure: firstStop.zip,
                    "drop-off": lastStop.zip,
                    trailer: trailerType,
                    "for-date": load.pickupDate || today,
                    "use-other-sources": true,
                },
            }).then((res) => ({
                suggestedRpm: res.rate.average,
                suggestedRate: res.price.average,
            })),
        enabled: isOpen && !!firstStop && !!lastStop && !!trailerType,
        retry: false,
    });

    return (
        <TableRow className="border-0 hover:bg-transparent">
            <LoadboardTableCell
                colSpan={11}
                className={cn("border-0 border-none transition-all ease-linear", {
                    "leading-[0]": !isOpen,
                })}
                innerClassName={cn("overflow-hidden transition-all ease-linear p-0 max-h-0 h-0", {
                    "max-h-[388px] h-[388px]": isOpen && withTimestamps,
                    "max-h-[353px] h-[353px]": isOpen && !withTimestamps,
                })}
            >
                <div className="p-4 flex flex-col w-full">
                    <div className="flex flex-col lg:flex-row w-full gap-4 h-[321px]">
                        <LoadboardMapSection load={load} isOpen={isOpen} />
                        <div className="w-full lg:w-[31.152205%] flex flex-col h-[321px] gap-4">
                            <LoadboardCargoInfo load={load} />
                            <LoadboardBrokerInfo load={load} />
                        </div>
                        <LoadboardBidCard load={load} CMRate={CMRate} isOpen={isOpen} />
                    </div>
                    {withTimestamps ? <LoadboardTimestamps createdAt={load.createdAt} updatedAt={load.updatedAt} /> : null}
                </div>
            </LoadboardTableCell>
        </TableRow>
    );
};
